module.exports = __webpack_public_path__ + "images/backgrounds/purty_wood_dark.7a14a57fef9435b0def0.png";